import React, { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import '../../styles/googleLogin.css';

const GooglePopup = () => {
  const { googleSSOLogin } = useAuth();
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  return (
    <div>
      <div className="custom-google-btn">
        <GoogleLogin
          onSuccess={async (credentialResponse) => {
            try {
              console.log("✅ Google token response:", credentialResponse);
              const result = await googleSSOLogin(credentialResponse.credential);
              console.log("✅ Google SSO login result:", result);

              navigate('/dashboard');
              
            } catch (err) {
              setError("Login failed. Please try again.");
              console.error(err);
            }
          }}
          onError={() => {
            setError("Google login failed");
          }}
          useOneTap={false}
        />
      </div>
      
      {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
    </div>
  );
};

export default GooglePopup;